import type { JSX } from 'react';
import { BRAND } from '../branding.js';

/**
 * Подвал страницы оплаты. Если у установки задана реферальная ссылка AllPay
 * (ALLPAY_REF_URL), вместо «Powered by <бренд>» — строка про Allpay со
 * ссылкой; так на проде и бете. Без неё — как раньше.
 */
export function PoweredBy(): JSX.Element {
  if (BRAND.allpayRefUrl) {
    return (
      <a
        href={BRAND.allpayRefUrl}
        target="_blank"
        rel="noopener sponsored"
        style={{ color: 'inherit', textDecoration: 'none' }}
      >
        Payments solution by <span style={{ textDecoration: 'underline' }}>Allpay</span>. The best
        payment provider in Israel.
      </a>
    );
  }
  return <>Powered by {BRAND.name}</>;
}
